import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    action_cart_checkout_set_paymethod,
    action_cart_checkout_set_shipping_method,
    action_cart_checkout_set_shipping_insurance,
    action_cart_checkout_set_coupon,
    action_cart_checkout_set_address,
    action_cart_checkout_set_default_address,
    action_cart_checkout_apply_points,
    action_cart_checkout_apply_cash,
    action_cart_checkout_unset_coupon,
    action_cart_checkout_use_coupon_code,
    setCheckoutEmpty
} from '../../../../../../store/actions/pages/cart'

import {
    TOOGLE_UI_ALERT
} from '../../../../../../store/actions/ui'

import {
    klarna_get_params,
    klarna_create_session
} from '../../../../../../api'

export default (onError) => {
    const dispatch = useDispatch()
    const pageCart = useSelector(state => state.pageCart)
    const { checkout } = pageCart
    const payMethodInfo = checkout?.payMethodList?.find(p => p.id === checkout?.payMethod)


    const handleError = checkout => {
        if (checkout) {
            if (checkout.errorCode === 402) {
                dispatch(setCheckoutEmpty(true))
                dispatch({
                    type: TOOGLE_UI_ALERT,
                    payload: {
                        show: true,
                        options: {
                            onConfirm: () => {
                                dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                            },
                            content: checkout.error
                        }
                    }
                })
            } else if (checkout.error) {
                dispatch({
                    type: TOOGLE_UI_ALERT,
                    payload: {
                        show: true,
                        options: {
                            onConfirm: () => {
                                dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                            },
                            content: checkout.error
                        }
                    }
                })
            }
        }

    }

    //klarna
    const [klarnas, setKlarnas] = useState(null)

    const selectPayMethodHandle = useCallback(async payMethod => {
        const checkout =await dispatch(action_cart_checkout_set_paymethod(payMethod))
        handleError(checkout)
        return checkout
    }, [])

    const selectShippingMethodHandle = useCallback(async data => {
        const checkout = await dispatch(action_cart_checkout_set_shipping_method(data))
        handleError(checkout)
        return checkout
    }, [])

    const selectShippingInsuranceHandle = useCallback(async data => {
        const checkout =await dispatch(action_cart_checkout_set_shipping_insurance(data))
        handleError(checkout)
        return checkout
    }, [])

    const selectCouponHandle = useCallback(async couponId => {
        let checkout
        if (couponId) {
            checkout =await dispatch(action_cart_checkout_set_coupon(couponId))
        } else {
            checkout =await dispatch(action_cart_checkout_unset_coupon())
        }
        handleError(checkout)
        return checkout
    }, [])

    const setAddressHandle = useCallback(async data => {
        const response = await dispatch(action_cart_checkout_set_address(data))
        return response
    }, [])

    const setDefaultAddressHandle = useCallback(async data => {
        const checkout =await dispatch(action_cart_checkout_set_default_address(data))
        handleError(checkout)
        return checkout
    }, [])

    const applyPointsHandle = useCallback(async points => {
        const checkout =await dispatch(action_cart_checkout_apply_points(points))
        handleError(checkout)
        return checkout
    }, [])

    const applyCashHandle = useCallback(async cash => {
        const checkout =await dispatch(action_cart_checkout_apply_cash(cash))
        handleError(checkout)
        return checkout
    }, [])

    const applyCouponCodeHandle = useCallback(async code => {
        return dispatch(action_cart_checkout_use_coupon_code(code))
    }, [])

    useEffect(async () => {
        const selectedPayMethod = checkout?.payMethodList?.find(p => p.id === checkout.payMethod)
        if (checkout && window.Klarna && selectedPayMethod?.type === '27') {
            const response = await klarna_create_session({ payMethod: checkout.payMethod })
            if (response?.code === 200 && response?.result) {
                const { client_token } = response.result
                window.Klarna.Payments.init({
                    client_token
                })
                const paramsResponse = await klarna_get_params({ payMethod: checkout.payMethod })
                if (paramsResponse?.code === 200 && paramsResponse?.result) {
                    const params = paramsResponse?.result
                    setKlarnas(params)
                }
            }
        }
    }, [checkout])

    return {
        selectPayMethodHandle,
        selectShippingMethodHandle,
        selectShippingInsuranceHandle,
        selectCouponHandle,
        setAddressHandle,
        setDefaultAddressHandle,
        applyPointsHandle,
        applyCashHandle,
        applyCouponCodeHandle,
        klarnas,
    }
}